export function formatCurrency(value) {
  return `R${Math.round(Number(value) || 0).toLocaleString("en-ZA")}`;
}

export function isConfirmedOrder(order) {
  return ["sale", "done"].includes(order?.state);
}

export function isDraftOrder(order) {
  return order?.state === "draft";
}
